"use client";

import { MenuItemCard } from "./menu-item-card";
import type { Doc } from "../../../convex/_generated/dataModel";

interface MenuGridProps {
  items: Doc<"menu_items">[];
  priorityImageUrls?: ReadonlySet<string>;
  /** Quick-add guard set forwarded to each card; null disables one-tap add. */
  quickAddRequiredIds?: Set<string> | null;
  /**
   * Opens the shared, surface-level customization sheet for a tapped item.
   * When omitted, each card falls back to its own local (lazy) sheet.
   */
  onSelect?: (item: Doc<"menu_items">) => void;
}

export function MenuGrid({
  items,
  priorityImageUrls = new Set(),
  quickAddRequiredIds = null,
  onSelect,
}: MenuGridProps) {
  if (items.length === 0) {
    return (
      <div className="py-12 text-center">
        <p className="text-sm text-muted-foreground">No items available in this category</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-2">
      {items.map((item, index) => (
        <div key={item._id} className="h-full">
          <MenuItemCard
            item={item}
            priority={index === 0 || priorityImageUrls.has(item.photoUrl ?? "")}
            quickAddRequiredIds={quickAddRequiredIds}
            onSelect={onSelect}
          />
        </div>
      ))}
    </div>
  );
}
